module.exports = __vendor;


//////////////////
// WEBPACK FOOTER
// external "__vendor"
// module id = 11
// module chunks = 0